import { Mixins, Component, Ref, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import CompanyAutocomplete from '@/components/Autocomplete/company.vue'
import PhoneInput from '@/_components/input/phone/phone.vue'
import User from '@/views/User/models/user'
import router from '@/_router'
@Component({
    components: { CompanyAutocomplete, PhoneInput },
})
export default class Signup extends Mixins<MixinInterface>() {
    @Ref('form') readonly form!: HTMLFormElement

    invitationEmail: any = false
    valid = true
    loading = false

    firstName = ''
    middleName = ''
    lastName = ''
    primaryEmail: any = ''
    phoneNumber = ''
    company: any = null
    error: string | null = null
    beNumberValidation = true

    get allowRegisterWithoutPhone() {
        return Boolean(process.env.VUE_APP_ALLOW_REGISTER_WITHOUT_PHONE)
    }

    @Watch('phoneNumber')
    resetPhoneValidation() {
        this.beNumberValidation = true
    }
    async signUp() {
        this.valid = this.form.validate()

        if (this.valid && !this.loading) {
            this.loading = true

            let data = {
                type: 'user',
                attributes: {
                    firstName: this.firstName,
                    ...(this.middleName && { middleName: this.middleName }),
                    ...(this.phoneNumber && { mobileNumber: this.phoneNumber }),
                    lastName: this.lastName,
                    primaryEmail: this.primaryEmail,
                    language: this.userLanguage,
                },
                relationships: {
                    employer: {
                        data: this.company ? { type: 'company', id: this.company.id } : null,
                    },
                },
            }

            let res = await User.post(data, true)

            if (res && res.status == 202) {
                this.$router.push({
                    name: 'sign-up-email-sent',
                    query: { email: this.primaryEmail },
                })
            }

            if (res && res.code) {
                if (res.code == 'invaliMobileNumber') {
                    this.beNumberValidation = false
                } else if (res.code == 'emailExistsOnOtherUser') {
                    this.$store.commit('emailExistsOnOtherUser', {
                        emailExistsOnOtherUser: true,
                        email: this.primaryEmail,
                    })
                    router.push({
                        name: 'sign-in',
                    })
                } else if (res.code == 'mobileExistsOnOtherUser') {
                    this.$store.commit('mobileExistsOnOtherUser', {
                        mobileExistsOnOtherUser: true,
                        email: this.primaryEmail,
                        mobile: this.phoneNumber,
                    })
                    router.push({
                        name: 'sign-in',
                    })
                }
            }

            // this.loading = false
        } else {
            for (const input of this.form.inputs) {
                if (!input.valid) {
                    input.focus()
                    break
                }
            }
        }
    }

    created() {
        if (this.$route.query.email) {
            this.invitationEmail = true
            this.primaryEmail = this.$route.query.email
        }
    }
}
